import type { CardBrand, ValuesOf } from "./enums";

export interface card {
    id: string;
    accountId: number;
    cardId: number;
    name: string;
    brand: ValuesOf<typeof CardBrand>;
    lastFour: string;
    expMonth: number;
    expYear: number;
    cvc: number;
    fingerprint: string;
}

export interface Card extends card {
    account: string;
}

export const transformCard = ({ id, ...rest }: Card) => {
    return rest;
};